export const changeHierarchyTableTo = (table) => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_HIERARCHY_TABLE_TO", payload: table });
  };
};
